import React from 'react';
import { Box } from '@mui/material';
import { useState } from 'hooks';
import { SidebarTitle } from '../types/sidebar-title.enum';
import { SidebarItemTitle } from '../types/sidebar-item.type';
import { SideBarGroup } from './sidebar-group';
import { SIDEBAR_MIDDLE_GROUP, SIDEBAR_TOP_GROUP, PARTNER_SIDEBAR_TOP_GROUP } from '../constants/constants';
import { useAppSelector } from 'hooks';
import { UserRole } from 'types/enums';

export const SideBarItems = () => {
  const [selected, setSelected] = useState<SidebarItemTitle>(SidebarTitle.DASHBOARD);
  const userData = useAppSelector(({ user }) => user.data);
  const userRole = userData?.role;

  const isPartner = userRole === UserRole.PARTNER;

  if (isPartner) {
    return (
      <Box>
        <SideBarGroup items={PARTNER_SIDEBAR_TOP_GROUP.map((item) => ({ ...item, selected, setSelected }))} />
      </Box>
    );
  }

  return (
    <Box>
      <SideBarGroup items={SIDEBAR_TOP_GROUP.map((item) => ({ ...item, selected, setSelected }))} />
      <SideBarGroup
        groupTitle='Pages'
        items={SIDEBAR_MIDDLE_GROUP.map((item) => ({ ...item, selected, setSelected }))}
      />
    </Box>
  );
};
